<template> 
    <div class="contact">
        <Carousel :slides="bannerData.list" :isShowIndicators="false" class="banner-img">
            <template #slide="{ slide }">
                <img :src="slide.image_url" class="banner-img"> 
                <div class="banner-des">
                    <div class="title">{{ slide.title }}</div>
                    <div class="summary">{{ slide.summary }}</div>  
                </div>
            </template>
        </Carousel>
    </div> 
</template>

<script setup>
    import Carousel from '@/components/carousel/index.vue'
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI } from '@/api/common.js';
    import { useRouter } from 'vue-router'
    const router = useRouter()

    const props = defineProps({
        name: { type: Object }
    })

    // banner数据
    const bannerData = ref({})

    // banner获取
    const getBannerList = () =>{
        const { name } = props
        ConfigGetAPI({ name }).then(res=>{
            bannerData.value = res
        });
    }

    onMounted(() => {
        getBannerList()
    });

</script>

<style lang="scss" scoped>

.banner-img {
    width: 100%;
    height: 600px;
    object-fit: cover;
    position: relative;
    color: #FFFFFF;    

    .banner-des {
        width: 1200px;
        height: 600px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        justify-content: center;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 88;
        text-align: center;

         .title {
            font-family: PingFangSC-semibold;
            font-weight: 600;
            font-size: 70px;
            letter-spacing: 6px; 
            margin-bottom: 24px;  
        } 

        .summary {
            font-weight: 400;
            font-size: 40px;
            letter-spacing: 3px;
        }
        
    }    
}
/* 响应式布局 */
@media (max-width: 768px) {
.banner-img {
    width: 100%;
    height: 200px;  

    .banner-des {
        height: 200px;
        max-width: 75%;
        
         .title {
            font-size: 25px;
            letter-spacing: 2px; 
            margin-bottom: 10px;  
            line-height: 30px;
        } 

        .summary {
            font-weight: 500;
            font-size: 12px;
            letter-spacing: 1px; 
        }
        
    }    
}
}

</style>
    

